<template>
  <span>toto</span>
</template>

<script>
import store from "@/store";
import AuthService from "@/services/AuthService";

export default {
  data() {
    return {
      access_token: "",
      expires_in: "",
      scope: "",
      returnUrl: "",
    };
  },

  mounted() {
    // GET the token info from the url params
    this.access_token = this.$route.query.access_token;
    this.expires_in = Number(this.$route.query.expires_in);
    this.scope = this.$route.query.scope;
    this.returnUrl = this.$route.query.returnUrl;

    // Process
    this.processAuth();
  },

  methods: {
    async processAuth() {
      // If we have all the params
      if (this.access_token && this.expires_in && this.scope) {
        const loginResponse = {
          access_token: this.access_token,
          expires_in: this.expires_in,
          refresh_token: null,
          token_type: null,
        };

        // Set the redirection url
        AuthService.loginRedirectUrl = this.returnUrl;

        // Decode the token in order to save all the claims (user, roles, permissions, etc.) in the local storage
        await AuthService.processLoginResponseFromAdfsRedirect(loginResponse);

        //   // Store the tokens in the local storage
        //   AuthService.storeAccessTokenResponse(
        //     this.access_token,
        //     null,
        //     this.expires_in,
        //     this.scope
        //   );

        // Redirect to home or to returnUrl
        AuthService.redirectLoginUserWithoutParams();
      }
      // Else we wanna redirect on not found
      else {
        // Display a message
        store.dispatch("setSnackbar", {
          title: "Erreur redirection ADFS",
          text: "Une erreur s'est produite lors de la réception des paramètres d'authentification via ADFS.",
          status: "error",
          timeout: 2000,
        });

        // Redirect to login
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<style lang="scss">
</style>